(function(){
  'use strict';

  var MAX_RESULTS = null; // V1.6: show every matching verified result
  var records = null;
  var loading = null;

  function norm(v){ return String(v == null ? '' : v).trim(); }
  function low(v){ return norm(v).toLowerCase(); }
  function compact(v){ return low(v).replace(/[^a-z0-9]/g,''); }
  function digits(v){ return compact(v).replace(/\D/g,'').replace(/^0+(?=\d)/,''); }
  function displayModel(r){ return norm(r.display_model || r.model); }
  function displayRef(r){ return norm(r.display_reference || r.canonical_reference || r.reference); }
  function width(r){ return Number(r.lug_width_mm || r.width || 0); }

  function recordText(r){
    var extras = []
      .concat(r.aliases || [])
      .concat(r.source_model_aliases || [])
      .concat(r.search_terms || []);
    return [r.brand, displayModel(r), r.model, r.reference, r.canonical_reference, r.display_reference, extras.join(' ')].join(' ').toLowerCase();
  }

  function loadDb(){
    if (records) return Promise.resolve(records);
    if (loading) return loading;
    loading = window.DaLucaWatchData.load()
      .then(function(json){
        var list = Array.isArray(json && json.records) ? json.records : [];
        records = list.filter(function(r){
          if (!r || !r.brand || !r.model || !r.reference || !width(r)) return false;
          var status = norm(r.verification_status).toUpperCase();
          return status.indexOf('VERIFIED') === 0;
        });
        return records;
      })
      .catch(function(err){
        console.warn('[DaLuca fit search] database unavailable', err);
        records = [];
        return records;
      });
    return loading;
  }

  function scoreRecord(r, q){
    var qt = low(q);
    var qc = compact(q);
    var qd = digits(q);
    if (!qt) return 9999;

    var brand = low(r.brand);
    var model = low(displayModel(r));
    var ref = low(displayRef(r));
    var rc = compact(displayRef(r));
    var rd = digits(displayRef(r));
    var text = recordText(r);
    var tc = compact(text);

    if (qc && rc === qc) return 0;
    if (qd && rd === qd) return 1;
    if (compact(brand + ' ' + model + ' ' + ref) === qc) return 2;
    if (compact(brand + ref) === qc) return 3;
    if (compact(model + ref) === qc) return 4;
    if (qc && rc.indexOf(qc) === 0) return 5;
    if (qd && rd.indexOf(qd) === 0) return 6;
    if (brand.indexOf(qt) === 0 && model.indexOf(qt) !== -1) return 7;
    if (model.indexOf(qt) === 0) return 8;
    if (brand.indexOf(qt) === 0) return 9;
    if (text.indexOf(qt) !== -1) return 10;
    if (qc && tc.indexOf(qc) !== -1) return 11;
    return 9999;
  }

  function resultsFor(q){
    if (!records || !records.length) return [];
    var query = norm(q);
    if (!query) return [];

    var seen = Object.create(null);
    return records
      .map(function(r){ return {r:r, s:scoreRecord(r, query)}; })
      .filter(function(x){ return x.s < 9999; })
      .sort(function(a,b){
        if (a.s !== b.s) return a.s - b.s;
        var ab = norm(a.r.brand).localeCompare(norm(b.r.brand));
        if (ab) return ab;
        var am = displayModel(a.r).localeCompare(displayModel(b.r));
        if (am) return am;
        return displayRef(a.r).localeCompare(displayRef(b.r));
      })
      .filter(function(x){
        var key = [low(x.r.brand), low(displayModel(x.r)), compact(displayRef(x.r)), width(x.r)].join('|');
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      })
      .map(function(x){ return x.r; });
  }

  function setLugWidth(r, form){
    var w = width(r);
    if (!w) return false;
    var root = form.closest('.daluca-custom-builder-live') || document;
    var select = root.querySelector('[data-daluca-field-name="Lug Width"] select') ||
                 root.querySelector('select[data-field-name="Lug Width"]') ||
                 root.querySelector('select[name="Lug Width"]');
    if (!select) return false;

    var wanted = String(w).replace(/\.0+$/,'') + 'mm';
    var option = Array.prototype.find.call(select.options, function(o){
      return low(o.value) === low(wanted) || low(window.DaLucaI18n.sourceText(o)) === low(wanted) || parseFloat(o.value) === w;
    });
    if (!option) return false;

    select.value = option.value;
    option.selected = true;
    select.dispatchEvent(new Event('input', {bubbles:true}));
    select.dispatchEvent(new Event('change', {bubbles:true}));
    return true;
  }

  function install(){
    var form = document.querySelector('.daluca-custom-builder-live .daluca-fit-search');
    if (!form || form.dataset.dalucaAutocompleteBound === '1') return;
    var input = form.querySelector('#daluca-custom-watch-search, input[type="search"]');
    var bar = form.querySelector('.daluca-fit-search__bar');
    var hint = form.querySelector('.daluca-fit-search__hint');
    if (!input || !bar) return;

    form.dataset.dalucaAutocompleteBound = '1';
    input.setAttribute('role','combobox');
    input.setAttribute('aria-autocomplete','list');
    input.setAttribute('aria-expanded','false');

    var list = document.createElement('div');
    list.className = 'daluca-fit-search__suggestions';
    list.id = 'daluca-fit-search-suggestions';
    list.setAttribute('role','listbox');
    list.hidden = true;
    bar.appendChild(list);
    input.setAttribute('aria-controls', list.id);

    var current = [];
    var active = -1;
    var timer = null;

    function close(){
      list.hidden = true;
      window.DaLucaI18n.setHtml(list, '');
      active = -1;
      input.setAttribute('aria-expanded','false');
      input.removeAttribute('aria-activedescendant');
    }

    function setActive(next){
      var items = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
      if (!items.length) return;
      if (next < 0) next = items.length - 1;
      if (next >= items.length) next = 0;
      active = next;
      items.forEach(function(el, i){ el.classList.toggle('is-active', i === active); });
      var el = items[active];
      if (el){
        input.setAttribute('aria-activedescendant', el.id);
        el.scrollIntoView({block:'nearest'});
      }
    }

    function choose(index){
      var r = current[index];
      if (!r) return;
      var model = displayModel(r);
      var ref = displayRef(r);
      input.value = [norm(r.brand), model].filter(Boolean).join(' ') + (ref ? ' · ' + ref : '');
      var didSet = setLugWidth(r, form);
      if (hint){
        window.DaLucaI18n.setText(hint, didSet
          ? 'Confirmed: this reference uses ' + width(r) + 'mm lugs. Lug Width has been selected below.'
          : 'Confirmed: this reference uses ' + width(r) + 'mm lugs.');
        hint.classList.add('is-confirmed');
      }
      close();
      input.blur();
    }

    function render(){
      var q = norm(input.value);
      if (!q){ close(); return; }
      current = resultsFor(q);
      active = -1;
      if (!current.length){
        window.DaLucaI18n.setHtml(list, '<div class="daluca-fit-search__empty">No exact match yet. Keep typing a brand, model, or reference.</div>');
        list.hidden = false;
        input.setAttribute('aria-expanded','true');
        return;
      }

      window.DaLucaI18n.setHtml(list, current.map(function(r, i){
        var model = displayModel(r);
        var ref = displayRef(r);
        var w = width(r);
        return '<button type="button" class="daluca-fit-search__suggestion" role="option" id="daluca-fit-option-' + i + '" data-index="' + i + '">' +
          '<span class="daluca-fit-search__suggestion-main"><strong>' + escapeHtml(r.brand) + ' ' + escapeHtml(model) + '</strong><small>Ref. ' + escapeHtml(ref) + '</small></span>' +
          '<span class="daluca-fit-search__suggestion-width">' + escapeHtml(String(w)) + 'mm</span>' +
        '</button>';
      }).join(''));
      list.hidden = false;
      input.setAttribute('aria-expanded','true');
    }

    function escapeHtml(v){
      return norm(v).replace(/[&<>"']/g,function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]; });
    }

    loadDb().then(function(db){
      if (db.length && hint) window.DaLucaI18n.setText(hint, 'Start typing your brand, model, or reference and choose the exact watch below.');
      if (document.activeElement === input && norm(input.value)) render();
    });

    input.addEventListener('focus', function(){
      loadDb().then(function(){ if (norm(input.value)) render(); });
    });

    input.addEventListener('input', function(){
      if (hint){ hint.classList.remove('is-confirmed'); }
      clearTimeout(timer);
      timer = setTimeout(function(){ loadDb().then(render); }, 80);
    });

    input.addEventListener('keydown', function(e){
      if (list.hidden) return;
      if (e.key === 'ArrowDown'){
        e.preventDefault();
        setActive(active + 1);
      } else if (e.key === 'ArrowUp'){
        e.preventDefault();
        setActive(active - 1);
      } else if (e.key === 'Enter' && active >= 0){
        e.preventDefault();
        e.stopPropagation();
        choose(active);
      } else if (e.key === 'Escape'){
        e.preventDefault();
        close();
      }
    });

    list.addEventListener('mousedown', function(e){ e.preventDefault(); });
    list.addEventListener('click', function(e){
      var button = e.target.closest('[data-index]');
      if (!button) return;
      e.preventDefault();
      choose(Number(button.dataset.index));
    });

    document.addEventListener('click', function(e){
      if (!form.contains(e.target)) close();
    });
  }

  function boot(){
    install();
    var tries = 0;
    var timer = setInterval(function(){
      install();
      tries += 1;
      if (tries > 30 || document.querySelector('.daluca-fit-search[data-daluca-autocomplete-bound="1"]')) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();

